<script setup lang="ts">
const { isMobile } = useBreakpoint()
const { locale } = useI18n()
const { trackEvent } = useTracking()

const path = computed(() => {
  switch (locale.value) {
    case 'fr':
      return '/fr/location-villas-luxe/piscine-privee'
    case 'en':
    default:
      return '/en/luxury-villas-rentals/private-pool'
  }
})

const onClickHotDeals = () => {
  trackEvent({
    event: 'search_favourites_click',
  })
}
</script>

<template>
  <BaseRow
    class="flex flex-nowrap items-center gap-8 bg-primary-100 px-3 py-4 text-xs sm:mx-0.5 sm:mb-4 sm:px-4 sm:text-md md:gap-4"
  >
    <div class="flex items-center gap-2">
      <BaseIcon v-if="!isMobile" class="flex-none" name="calendar" />
      <p class="m-0">
        {{ $t('search.hotdeals.text') }}
      </p>
    </div>

    <NuxtLink
      class="flex-none py-3 text-xs font-bold text-gray-700 underline md:py-0 md:text-md"
      type="button"
      :to="path"
      @click.prevent="onClickHotDeals"
    >
      {{ $t('search.hotdeals.link') }}
    </NuxtLink>
  </BaseRow>
</template>
